import { type DexCoords } from './coords.model'
import { type DexEntityType } from './entity.model'

export enum DexOverlayType {
  POWER_CONTEXT_MENU = 'POWER_CONTEXT_MENU',
  PATTERN_CONTEXT_MENU = 'PATTERN_CONTEXT_MENU',
  GRAPH_CONTEXT_MENU = 'GRAPH_CONTEXT_MENU',
  GRAPH_ELEMENT_MENU = 'GRAPH_ELEMENT_MENU',
  GRAPH_DEPENDENCY_MENU = 'GRAPH_DEPENDENCY_MENU',
  ENTITY_DETAILS = 'ENTITY_DETAILS',
  DEBUG_DOT = 'DEBUG_DOT',
}

export enum DexOverlayTarget {
  EDITOR_VIEW = 'EDITOR_VIEW',
  GRAPH_STAGE = 'GRAPH_STAGE',
  GRAPH_NODE = 'GRAPH_NODE',
  GRAPH_EDGE = 'GRAPH_EDGE',
  MATRIX_COL = 'MATRIX_COL',
  MATRIX_ROW = 'MATRIX_ROW',
  MATRIX_CELL = 'MATRIX_CELL',
}

export enum DexAnchorPosition {
  TOP_LEFT = 'top-left',
  TOP = 'top',
  TOP_RIGHT = 'top-right',
  RIGHT = 'right',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM = 'bottom',
  BOTTOM_LEFT = 'bottom-left',
  LEFT = 'left',
  CENTER = 'center',
}

export interface DexOverlayInstance {
  id: string
  type: DexOverlayType
  open: boolean
  coords: { x: number; y: number }
  backdropEnabled?: boolean
  anchor?: DexAnchorPosition
  anchorOffsetX?: string
  anchorOffsetY?: string
  targetType?: DexEntityType
  targetIds?: string[]
  event?: MouseEvent
  clientCoords?: DexCoords
}
